import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrototypeCountQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
}>;


export type PrototypeCountQuery = { prototypeCount: number };

export type GetGlCharacteristicsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGlCharacteristicsQuery = { glCharacteristics: Array<{ label: string, code: string, options: Array<{ label: string, value: string }> }> };

export type GetPrototypeCertificationsQueryVariables = Types.Exact<{
  prototypeId: Types.Scalars['String'];
  glId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetPrototypeCertificationsQuery = { getPrototypeCertifications: Array<{ id: string, date: string, user: string, status?: string | null, statusLabel?: string | null, errorMessage?: string | null }> };

export type GetPrototypesGlAlignmentQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
}>;


export type GetPrototypesGlAlignmentQuery = { getPrototypesGlAlignment: Array<{ prototypeId: string, outdated: boolean }> };

export type GetPrototypesQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
}>;


export type GetPrototypesQuery = { getPrototypes: Array<{ _rev?: string | null, id: string, code: string, parent: string, nodePublished: Types.CtgStatus, hasBeenCertified?: boolean | null, certificationStatus?: string | null, linkedBy?: Array<{ nodeId: string } | null> | null, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus, publishedAt?: string | null }> | null, metadata?: { updatedAt?: any | null, updatedBy?: string | null } | null, contents?: Array<{ contentTypeGroup: string, contentTypeGroupIndex: number, contentType: string, repeatable?: boolean | null, type: string, inherited: boolean, value?: Array<{ languageIsoCode: string, value: Array<any | null>, code?: string | null, measure?: string | null }> | null }> | null }> };

export type GetModelGlsStatusesQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  glIds?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type GetModelGlsStatusesQuery = { modelGlsStatuses: Array<{ glId: string, glCode: string, glHierarchyId: string, hasCompatiblePriceLists?: boolean | null, statuses: Array<{ status: Types.ModelGlStatus, data?: Array<string> | null, items?: Array<{ code: string, replacedBy: string }> | null }> }> };

export type GetPrototypeGlVersionsQueryVariables = Types.Exact<{
  glId: Types.Scalars['String'];
  certificationIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type GetPrototypeGlVersionsQuery = { getPrototypeGlVersions: { glCode: string, prices: { version0?: { versionId: string, versionDate: string, rows: { listino?: number | null, dn?: number | null, lc?: number | null, tpa?: number | null, gp?: number | null, ms?: number | null, mo?: number | null } } | null, version1?: { versionId: string, versionDate: string, rows: { listino?: number | null, dn?: number | null, lc?: number | null, tpa?: number | null, gp?: number | null, ms?: number | null, mo?: number | null } } | null }, items: Array<{ itemId: string, version0?: { versionId: string, versionDate: string, prices: { dn?: number | null } } | null, version1?: { versionId: string, versionDate: string, prices: { dn?: number | null } } | null }> } };

export type GetGlLinkedModelsInfoQueryVariables = Types.Exact<{
  glId: Types.Scalars['String'];
  modelId: Types.Scalars['String'];
}>;


export type GetGlLinkedModelsInfoQuery = { glLinkedModelsInfo: Array<{ id: string, modelName: string, deltaPrezzoStandard: string, dn: string, lc: string, tpa: string, gp: string, ms: string, mo: string, listPrice: string, listinoForn: boolean, markup: string, status: string, c1: string, c2: string, c3: string, dnCashD: string, lcPerc: string, transportCosts: string, prototypesForcingListPrice: Array<string>, prototypesForcingTransportCosts: Array<string> }> };

export type GetSelectedGlsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  glIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type GetSelectedGlsQuery = { getSelectedGls: Array<{ id: string, hierarchyId: string, code: string, denomination: string, description: string, family: string, type: string, items: Array<{ id: string, quantity: string, positionType: Types.ItemPositionType }> }> };

export type GetSelectedDgsQueryVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  dgsIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type GetSelectedDgsQuery = { getSelectedDgs: Array<{ id: string, hierarchyId: string, code: string, material: string, description: string, base_unit: string, list_price: string }> };

export type GetMatchingLongListsQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  pagination: Types.Pagination;
  sort: Array<Types.Sort> | Types.Sort;
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
}>;


export type GetMatchingLongListsQuery = { searchHierarchies: { nodes: { count: number, pageInfo: { hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: string, code: string, parent: string, parentCode: string, hierarchy: string, hierarchyCode: string, disabled: boolean, nodePublished: Types.CtgStatus, writeRoles?: Array<string> | null, createdAt: number, updatedAt: number, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus }> | null, linkListNames?: Array<{ hierarchyId: string, code: string, listName?: string | null }> | null, contents: Array<{ contentType: string, contentTypeGroup: string, type: string, inherited: boolean, contentTypeGroupIndex: number, repeatable?: boolean | null, value?: Array<{ code?: string | null, value: Array<any | null>, languageIsoCode: string, measure?: string | null, approvedValue?: Array<any | null> | null }> | null }>, metadata?: { createdAt?: any | null, updatedAt?: any | null } | null } }> } } };

export type CreatePrototypeMutationVariables = Types.Exact<{
  modelName: Types.Scalars['String'];
  prototypeCode: Types.Scalars['String'];
}>;


export type CreatePrototypeMutation = { createPrototype?: { code: string, success: boolean, message: string } | null };

export type CreateLongListMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  commercialFamilyId: Types.Scalars['String'];
  commercialFamilyParentId: Types.Scalars['String'];
  prototypeId: Types.Scalars['String'];
}>;


export type CreateLongListMutation = { createLongList?: { code: string, success: boolean, message: string } | null };

export type DuplicatePrototypeMutationVariables = Types.Exact<{
  modelName: Types.Scalars['String'];
  prototypeId: Types.Scalars['String'];
  prototypeCode: Types.Scalars['String'];
  contents?: Types.InputMaybe<Array<Types.NodeContent> | Types.NodeContent>;
}>;


export type DuplicatePrototypeMutation = { duplicatePrototype?: { code: string, success: boolean, message: string } | null };

export type ApproveLongListMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  node: Types.Scalars['String'];
  prototypeId: Types.Scalars['String'];
}>;


export type ApproveLongListMutation = { approveLongList: { success: boolean } };

export type PublishLongListMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  publishedDocumentId: Types.Scalars['String'];
  cgtModelId: Types.Scalars['String'];
  prototypeId: Types.Scalars['String'];
}>;


export type PublishLongListMutation = { publishLongList: { success: boolean, masterPropagationError?: string | null, masterPropagation?: Array<{ schedaId: string, code: string, action: Types.PendingMasterAction, outcome: Types.MasterPropagationOutcome, message?: string | null }> | null } };

export type UnpublishLongListMutationVariables = Types.Exact<{
  nodeId: Types.Scalars['String'];
  publishedDocumentId: Types.Scalars['String'];
  prototypeId: Types.Scalars['String'];
}>;


export type UnpublishLongListMutation = { unpublishLongList: { success: boolean } };

export type ChangeFamilyMutationVariables = Types.Exact<{
  longListParent: Types.Scalars['String'];
  longListId: Types.Scalars['String'];
  familyId: Types.Scalars['String'];
}>;


export type ChangeFamilyMutation = { changeLongListCommercialFamily?: { code: string, success: boolean, message: string } | null };

export type SaveTrasversalGlsMutationVariables = Types.Exact<{
  glData: Array<Types.GlData> | Types.GlData;
  modelIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type SaveTrasversalGlsMutation = { saveTrasversalGls?: { code: string, success: boolean, message: string } | null };

export type SavePrototypeGlForcedValuesMutationVariables = Types.Exact<{
  modelId: Types.Scalars['String'];
  prototypes: Array<Types.PrototypeGlForcedValues> | Types.PrototypeGlForcedValues;
}>;


export type SavePrototypeGlForcedValuesMutation = { savePrototypeGlForcedValues?: { code: string, success: boolean, message: string } | null };

export type UpdateCertificationStatusMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  contents: Array<Types.NodeContent> | Types.NodeContent;
  documentVersion?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateCertificationStatusMutation = { updateCertificationStatus?: { code: string, success: boolean, message: string } | null };


export const PrototypeCountDocument = gql`
    query PrototypeCount($modelId: String!) {
  prototypeCount(modelId: $modelId)
}
    `;

/**
 * __usePrototypeCountQuery__
 *
 * To run a query within a React component, call `usePrototypeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrototypeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrototypeCountQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function usePrototypeCountQuery(baseOptions: Apollo.QueryHookOptions<PrototypeCountQuery, PrototypeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrototypeCountQuery, PrototypeCountQueryVariables>(PrototypeCountDocument, options);
      }
export function usePrototypeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrototypeCountQuery, PrototypeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrototypeCountQuery, PrototypeCountQueryVariables>(PrototypeCountDocument, options);
        }
export type PrototypeCountQueryHookResult = ReturnType<typeof usePrototypeCountQuery>;
export type PrototypeCountLazyQueryHookResult = ReturnType<typeof usePrototypeCountLazyQuery>;
export type PrototypeCountQueryResult = Apollo.QueryResult<PrototypeCountQuery, PrototypeCountQueryVariables>;
export const GetGlCharacteristicsDocument = gql`
    query GetGlCharacteristics {
  glCharacteristics {
    label
    code
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useGetGlCharacteristicsQuery__
 *
 * To run a query within a React component, call `useGetGlCharacteristicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlCharacteristicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlCharacteristicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlCharacteristicsQuery(baseOptions?: Apollo.QueryHookOptions<GetGlCharacteristicsQuery, GetGlCharacteristicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlCharacteristicsQuery, GetGlCharacteristicsQueryVariables>(GetGlCharacteristicsDocument, options);
      }
export function useGetGlCharacteristicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlCharacteristicsQuery, GetGlCharacteristicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlCharacteristicsQuery, GetGlCharacteristicsQueryVariables>(GetGlCharacteristicsDocument, options);
        }
export type GetGlCharacteristicsQueryHookResult = ReturnType<typeof useGetGlCharacteristicsQuery>;
export type GetGlCharacteristicsLazyQueryHookResult = ReturnType<typeof useGetGlCharacteristicsLazyQuery>;
export type GetGlCharacteristicsQueryResult = Apollo.QueryResult<GetGlCharacteristicsQuery, GetGlCharacteristicsQueryVariables>;
export const GetPrototypeCertificationsDocument = gql`
    query GetPrototypeCertifications($prototypeId: String!, $glId: String) {
  getPrototypeCertifications(prototypeId: $prototypeId, glId: $glId) {
    id
    date
    user
    status
    statusLabel
    errorMessage
  }
}
    `;

/**
 * __useGetPrototypeCertificationsQuery__
 *
 * To run a query within a React component, call `useGetPrototypeCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrototypeCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrototypeCertificationsQuery({
 *   variables: {
 *      prototypeId: // value for 'prototypeId'
 *      glId: // value for 'glId'
 *   },
 * });
 */
export function useGetPrototypeCertificationsQuery(baseOptions: Apollo.QueryHookOptions<GetPrototypeCertificationsQuery, GetPrototypeCertificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrototypeCertificationsQuery, GetPrototypeCertificationsQueryVariables>(GetPrototypeCertificationsDocument, options);
      }
export function useGetPrototypeCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrototypeCertificationsQuery, GetPrototypeCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrototypeCertificationsQuery, GetPrototypeCertificationsQueryVariables>(GetPrototypeCertificationsDocument, options);
        }
export type GetPrototypeCertificationsQueryHookResult = ReturnType<typeof useGetPrototypeCertificationsQuery>;
export type GetPrototypeCertificationsLazyQueryHookResult = ReturnType<typeof useGetPrototypeCertificationsLazyQuery>;
export type GetPrototypeCertificationsQueryResult = Apollo.QueryResult<GetPrototypeCertificationsQuery, GetPrototypeCertificationsQueryVariables>;
export const GetPrototypesGlAlignmentDocument = gql`
    query GetPrototypesGlAlignment($modelId: String!) {
  getPrototypesGlAlignment(modelId: $modelId) {
    prototypeId
    outdated
  }
}
    `;

/**
 * __useGetPrototypesGlAlignmentQuery__
 *
 * To run a query within a React component, call `useGetPrototypesGlAlignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrototypesGlAlignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrototypesGlAlignmentQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetPrototypesGlAlignmentQuery(baseOptions: Apollo.QueryHookOptions<GetPrototypesGlAlignmentQuery, GetPrototypesGlAlignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrototypesGlAlignmentQuery, GetPrototypesGlAlignmentQueryVariables>(GetPrototypesGlAlignmentDocument, options);
      }
export function useGetPrototypesGlAlignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrototypesGlAlignmentQuery, GetPrototypesGlAlignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrototypesGlAlignmentQuery, GetPrototypesGlAlignmentQueryVariables>(GetPrototypesGlAlignmentDocument, options);
        }
export type GetPrototypesGlAlignmentQueryHookResult = ReturnType<typeof useGetPrototypesGlAlignmentQuery>;
export type GetPrototypesGlAlignmentLazyQueryHookResult = ReturnType<typeof useGetPrototypesGlAlignmentLazyQuery>;
export type GetPrototypesGlAlignmentQueryResult = Apollo.QueryResult<GetPrototypesGlAlignmentQuery, GetPrototypesGlAlignmentQueryVariables>;
export const GetPrototypesDocument = gql`
    query GetPrototypes($modelId: String!) {
  getPrototypes(modelId: $modelId) {
    _rev
    id
    code
    parent
    linkedBy {
      nodeId
    }
    contentTypeGroupStatus {
      code
      status
      publishedAt
    }
    nodePublished
    hasBeenCertified
    certificationStatus
    metadata {
      updatedAt
      updatedBy
    }
    contents {
      contentTypeGroup
      contentTypeGroupIndex
      contentType
      repeatable
      type
      inherited
      value {
        languageIsoCode
        value
        code
        measure
      }
    }
  }
}
    `;

/**
 * __useGetPrototypesQuery__
 *
 * To run a query within a React component, call `useGetPrototypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrototypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrototypesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetPrototypesQuery(baseOptions: Apollo.QueryHookOptions<GetPrototypesQuery, GetPrototypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrototypesQuery, GetPrototypesQueryVariables>(GetPrototypesDocument, options);
      }
export function useGetPrototypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrototypesQuery, GetPrototypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrototypesQuery, GetPrototypesQueryVariables>(GetPrototypesDocument, options);
        }
export type GetPrototypesQueryHookResult = ReturnType<typeof useGetPrototypesQuery>;
export type GetPrototypesLazyQueryHookResult = ReturnType<typeof useGetPrototypesLazyQuery>;
export type GetPrototypesQueryResult = Apollo.QueryResult<GetPrototypesQuery, GetPrototypesQueryVariables>;
export const GetModelGlsStatusesDocument = gql`
    query GetModelGlsStatuses($modelId: String!, $glIds: [String!]) {
  modelGlsStatuses(modelId: $modelId, glIds: $glIds) {
    glId
    glCode
    glHierarchyId
    statuses {
      status
      data
      items {
        code
        replacedBy
      }
    }
    hasCompatiblePriceLists
  }
}
    `;

/**
 * __useGetModelGlsStatusesQuery__
 *
 * To run a query within a React component, call `useGetModelGlsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelGlsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelGlsStatusesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      glIds: // value for 'glIds'
 *   },
 * });
 */
export function useGetModelGlsStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetModelGlsStatusesQuery, GetModelGlsStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelGlsStatusesQuery, GetModelGlsStatusesQueryVariables>(GetModelGlsStatusesDocument, options);
      }
export function useGetModelGlsStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelGlsStatusesQuery, GetModelGlsStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelGlsStatusesQuery, GetModelGlsStatusesQueryVariables>(GetModelGlsStatusesDocument, options);
        }
export type GetModelGlsStatusesQueryHookResult = ReturnType<typeof useGetModelGlsStatusesQuery>;
export type GetModelGlsStatusesLazyQueryHookResult = ReturnType<typeof useGetModelGlsStatusesLazyQuery>;
export type GetModelGlsStatusesQueryResult = Apollo.QueryResult<GetModelGlsStatusesQuery, GetModelGlsStatusesQueryVariables>;
export const GetPrototypeGlVersionsDocument = gql`
    query GetPrototypeGlVersions($glId: String!, $certificationIds: [String!]!) {
  getPrototypeGlVersions(glId: $glId, certificationIds: $certificationIds) {
    glCode
    prices {
      version0 {
        versionId
        versionDate
        rows {
          listino
          dn
          lc
          tpa
          gp
          ms
          mo
        }
      }
      version1 {
        versionId
        versionDate
        rows {
          listino
          dn
          lc
          tpa
          gp
          ms
          mo
        }
      }
    }
    items {
      itemId
      version0 {
        versionId
        versionDate
        prices {
          dn
        }
      }
      version1 {
        versionId
        versionDate
        prices {
          dn
        }
      }
    }
  }
}
    `;

/**
 * __useGetPrototypeGlVersionsQuery__
 *
 * To run a query within a React component, call `useGetPrototypeGlVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrototypeGlVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrototypeGlVersionsQuery({
 *   variables: {
 *      glId: // value for 'glId'
 *      certificationIds: // value for 'certificationIds'
 *   },
 * });
 */
export function useGetPrototypeGlVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetPrototypeGlVersionsQuery, GetPrototypeGlVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrototypeGlVersionsQuery, GetPrototypeGlVersionsQueryVariables>(GetPrototypeGlVersionsDocument, options);
      }
export function useGetPrototypeGlVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrototypeGlVersionsQuery, GetPrototypeGlVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrototypeGlVersionsQuery, GetPrototypeGlVersionsQueryVariables>(GetPrototypeGlVersionsDocument, options);
        }
export type GetPrototypeGlVersionsQueryHookResult = ReturnType<typeof useGetPrototypeGlVersionsQuery>;
export type GetPrototypeGlVersionsLazyQueryHookResult = ReturnType<typeof useGetPrototypeGlVersionsLazyQuery>;
export type GetPrototypeGlVersionsQueryResult = Apollo.QueryResult<GetPrototypeGlVersionsQuery, GetPrototypeGlVersionsQueryVariables>;
export const GetGlLinkedModelsInfoDocument = gql`
    query GetGlLinkedModelsInfo($glId: String!, $modelId: String!) {
  glLinkedModelsInfo(glId: $glId, modelId: $modelId) {
    id
    modelName
    deltaPrezzoStandard
    dn
    lc
    tpa
    gp
    ms
    mo
    listPrice
    listinoForn
    markup
    status
    c1
    c2
    c3
    dnCashD
    lcPerc
    transportCosts
    prototypesForcingListPrice
    prototypesForcingTransportCosts
  }
}
    `;

/**
 * __useGetGlLinkedModelsInfoQuery__
 *
 * To run a query within a React component, call `useGetGlLinkedModelsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlLinkedModelsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlLinkedModelsInfoQuery({
 *   variables: {
 *      glId: // value for 'glId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetGlLinkedModelsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetGlLinkedModelsInfoQuery, GetGlLinkedModelsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlLinkedModelsInfoQuery, GetGlLinkedModelsInfoQueryVariables>(GetGlLinkedModelsInfoDocument, options);
      }
export function useGetGlLinkedModelsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlLinkedModelsInfoQuery, GetGlLinkedModelsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlLinkedModelsInfoQuery, GetGlLinkedModelsInfoQueryVariables>(GetGlLinkedModelsInfoDocument, options);
        }
export type GetGlLinkedModelsInfoQueryHookResult = ReturnType<typeof useGetGlLinkedModelsInfoQuery>;
export type GetGlLinkedModelsInfoLazyQueryHookResult = ReturnType<typeof useGetGlLinkedModelsInfoLazyQuery>;
export type GetGlLinkedModelsInfoQueryResult = Apollo.QueryResult<GetGlLinkedModelsInfoQuery, GetGlLinkedModelsInfoQueryVariables>;
export const GetSelectedGlsDocument = gql`
    query GetSelectedGls($modelId: String!, $glIds: [String!]!) {
  getSelectedGls(modelId: $modelId, glIds: $glIds) {
    id
    hierarchyId
    code
    denomination
    description
    family
    type
    items {
      id
      quantity
      positionType
    }
  }
}
    `;

/**
 * __useGetSelectedGlsQuery__
 *
 * To run a query within a React component, call `useGetSelectedGlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedGlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedGlsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      glIds: // value for 'glIds'
 *   },
 * });
 */
export function useGetSelectedGlsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedGlsQuery, GetSelectedGlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedGlsQuery, GetSelectedGlsQueryVariables>(GetSelectedGlsDocument, options);
      }
export function useGetSelectedGlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedGlsQuery, GetSelectedGlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedGlsQuery, GetSelectedGlsQueryVariables>(GetSelectedGlsDocument, options);
        }
export type GetSelectedGlsQueryHookResult = ReturnType<typeof useGetSelectedGlsQuery>;
export type GetSelectedGlsLazyQueryHookResult = ReturnType<typeof useGetSelectedGlsLazyQuery>;
export type GetSelectedGlsQueryResult = Apollo.QueryResult<GetSelectedGlsQuery, GetSelectedGlsQueryVariables>;
export const GetSelectedDgsDocument = gql`
    query GetSelectedDgs($modelId: String!, $dgsIds: [String!]!) {
  getSelectedDgs(modelId: $modelId, dgsIds: $dgsIds) {
    id
    hierarchyId
    code
    material
    description
    base_unit
    list_price
  }
}
    `;

/**
 * __useGetSelectedDgsQuery__
 *
 * To run a query within a React component, call `useGetSelectedDgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedDgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedDgsQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      dgsIds: // value for 'dgsIds'
 *   },
 * });
 */
export function useGetSelectedDgsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedDgsQuery, GetSelectedDgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedDgsQuery, GetSelectedDgsQueryVariables>(GetSelectedDgsDocument, options);
      }
export function useGetSelectedDgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedDgsQuery, GetSelectedDgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedDgsQuery, GetSelectedDgsQueryVariables>(GetSelectedDgsDocument, options);
        }
export type GetSelectedDgsQueryHookResult = ReturnType<typeof useGetSelectedDgsQuery>;
export type GetSelectedDgsLazyQueryHookResult = ReturnType<typeof useGetSelectedDgsLazyQuery>;
export type GetSelectedDgsQueryResult = Apollo.QueryResult<GetSelectedDgsQuery, GetSelectedDgsQueryVariables>;
export const GetMatchingLongListsDocument = gql`
    query GetMatchingLongLists($ids: [String!], $pagination: Pagination!, $sort: [Sort!]!, $filter: [SearchFilter!]!) {
  searchHierarchies: getMatchingLongLists(
    ids: $ids
    pagination: $pagination
    sort: $sort
    filter: $filter
  ) {
    nodes {
      count
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          code
          parent
          parentCode
          hierarchy
          hierarchyCode
          disabled
          contentTypeGroupStatus {
            code
            status
          }
          linkListNames {
            hierarchyId
            code
            listName
          }
          contents {
            contentType
            contentTypeGroup
            type
            inherited
            contentTypeGroupIndex
            repeatable
            value {
              code
              value
              languageIsoCode
              measure
              approvedValue
            }
          }
          nodePublished
          writeRoles
          createdAt
          updatedAt
          metadata {
            createdAt
            updatedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchingLongListsQuery__
 *
 * To run a query within a React component, call `useGetMatchingLongListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchingLongListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchingLongListsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMatchingLongListsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchingLongListsQuery, GetMatchingLongListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchingLongListsQuery, GetMatchingLongListsQueryVariables>(GetMatchingLongListsDocument, options);
      }
export function useGetMatchingLongListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchingLongListsQuery, GetMatchingLongListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchingLongListsQuery, GetMatchingLongListsQueryVariables>(GetMatchingLongListsDocument, options);
        }
export type GetMatchingLongListsQueryHookResult = ReturnType<typeof useGetMatchingLongListsQuery>;
export type GetMatchingLongListsLazyQueryHookResult = ReturnType<typeof useGetMatchingLongListsLazyQuery>;
export type GetMatchingLongListsQueryResult = Apollo.QueryResult<GetMatchingLongListsQuery, GetMatchingLongListsQueryVariables>;
export const CreatePrototypeDocument = gql`
    mutation CreatePrototype($modelName: String!, $prototypeCode: String!) {
  createPrototype(modelName: $modelName, prototypeCode: $prototypeCode) {
    code
    success
    message
  }
}
    `;
export type CreatePrototypeMutationFn = Apollo.MutationFunction<CreatePrototypeMutation, CreatePrototypeMutationVariables>;

/**
 * __useCreatePrototypeMutation__
 *
 * To run a mutation, you first call `useCreatePrototypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrototypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrototypeMutation, { data, loading, error }] = useCreatePrototypeMutation({
 *   variables: {
 *      modelName: // value for 'modelName'
 *      prototypeCode: // value for 'prototypeCode'
 *   },
 * });
 */
export function useCreatePrototypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrototypeMutation, CreatePrototypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrototypeMutation, CreatePrototypeMutationVariables>(CreatePrototypeDocument, options);
      }
export type CreatePrototypeMutationHookResult = ReturnType<typeof useCreatePrototypeMutation>;
export type CreatePrototypeMutationResult = Apollo.MutationResult<CreatePrototypeMutation>;
export type CreatePrototypeMutationOptions = Apollo.BaseMutationOptions<CreatePrototypeMutation, CreatePrototypeMutationVariables>;
export const CreateLongListDocument = gql`
    mutation CreateLongList($aggregateId: String!, $commercialFamilyId: String!, $commercialFamilyParentId: String!, $prototypeId: String!) {
  createLongList(
    aggregateId: $aggregateId
    commercialFamilyId: $commercialFamilyId
    commercialFamilyParentId: $commercialFamilyParentId
    prototypeId: $prototypeId
  ) {
    code
    success
    message
  }
}
    `;
export type CreateLongListMutationFn = Apollo.MutationFunction<CreateLongListMutation, CreateLongListMutationVariables>;

/**
 * __useCreateLongListMutation__
 *
 * To run a mutation, you first call `useCreateLongListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLongListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLongListMutation, { data, loading, error }] = useCreateLongListMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      commercialFamilyId: // value for 'commercialFamilyId'
 *      commercialFamilyParentId: // value for 'commercialFamilyParentId'
 *      prototypeId: // value for 'prototypeId'
 *   },
 * });
 */
export function useCreateLongListMutation(baseOptions?: Apollo.MutationHookOptions<CreateLongListMutation, CreateLongListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLongListMutation, CreateLongListMutationVariables>(CreateLongListDocument, options);
      }
export type CreateLongListMutationHookResult = ReturnType<typeof useCreateLongListMutation>;
export type CreateLongListMutationResult = Apollo.MutationResult<CreateLongListMutation>;
export type CreateLongListMutationOptions = Apollo.BaseMutationOptions<CreateLongListMutation, CreateLongListMutationVariables>;
export const DuplicatePrototypeDocument = gql`
    mutation DuplicatePrototype($modelName: String!, $prototypeId: String!, $prototypeCode: String!, $contents: [NodeContent!]) {
  duplicatePrototype(
    modelName: $modelName
    prototypeId: $prototypeId
    prototypeCode: $prototypeCode
    contents: $contents
  ) {
    code
    success
    message
  }
}
    `;
export type DuplicatePrototypeMutationFn = Apollo.MutationFunction<DuplicatePrototypeMutation, DuplicatePrototypeMutationVariables>;

/**
 * __useDuplicatePrototypeMutation__
 *
 * To run a mutation, you first call `useDuplicatePrototypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePrototypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePrototypeMutation, { data, loading, error }] = useDuplicatePrototypeMutation({
 *   variables: {
 *      modelName: // value for 'modelName'
 *      prototypeId: // value for 'prototypeId'
 *      prototypeCode: // value for 'prototypeCode'
 *      contents: // value for 'contents'
 *   },
 * });
 */
export function useDuplicatePrototypeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePrototypeMutation, DuplicatePrototypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePrototypeMutation, DuplicatePrototypeMutationVariables>(DuplicatePrototypeDocument, options);
      }
export type DuplicatePrototypeMutationHookResult = ReturnType<typeof useDuplicatePrototypeMutation>;
export type DuplicatePrototypeMutationResult = Apollo.MutationResult<DuplicatePrototypeMutation>;
export type DuplicatePrototypeMutationOptions = Apollo.BaseMutationOptions<DuplicatePrototypeMutation, DuplicatePrototypeMutationVariables>;
export const ApproveLongListDocument = gql`
    mutation ApproveLongList($aggregateId: String!, $node: String!, $prototypeId: String!) {
  approveLongList(
    aggregateId: $aggregateId
    node: $node
    prototypeId: $prototypeId
  ) {
    success
  }
}
    `;
export type ApproveLongListMutationFn = Apollo.MutationFunction<ApproveLongListMutation, ApproveLongListMutationVariables>;

/**
 * __useApproveLongListMutation__
 *
 * To run a mutation, you first call `useApproveLongListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLongListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLongListMutation, { data, loading, error }] = useApproveLongListMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      node: // value for 'node'
 *      prototypeId: // value for 'prototypeId'
 *   },
 * });
 */
export function useApproveLongListMutation(baseOptions?: Apollo.MutationHookOptions<ApproveLongListMutation, ApproveLongListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveLongListMutation, ApproveLongListMutationVariables>(ApproveLongListDocument, options);
      }
export type ApproveLongListMutationHookResult = ReturnType<typeof useApproveLongListMutation>;
export type ApproveLongListMutationResult = Apollo.MutationResult<ApproveLongListMutation>;
export type ApproveLongListMutationOptions = Apollo.BaseMutationOptions<ApproveLongListMutation, ApproveLongListMutationVariables>;
export const PublishLongListDocument = gql`
    mutation PublishLongList($aggregateId: String!, $nodeId: String!, $publishedDocumentId: String!, $cgtModelId: String!, $prototypeId: String!) {
  publishLongList(
    aggregateId: $aggregateId
    nodeId: $nodeId
    publishedDocumentId: $publishedDocumentId
    cgtModelId: $cgtModelId
    prototypeId: $prototypeId
  ) {
    success
    masterPropagation {
      schedaId
      code
      action
      outcome
      message
    }
    masterPropagationError
  }
}
    `;
export type PublishLongListMutationFn = Apollo.MutationFunction<PublishLongListMutation, PublishLongListMutationVariables>;

/**
 * __usePublishLongListMutation__
 *
 * To run a mutation, you first call `usePublishLongListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishLongListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishLongListMutation, { data, loading, error }] = usePublishLongListMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      nodeId: // value for 'nodeId'
 *      publishedDocumentId: // value for 'publishedDocumentId'
 *      cgtModelId: // value for 'cgtModelId'
 *      prototypeId: // value for 'prototypeId'
 *   },
 * });
 */
export function usePublishLongListMutation(baseOptions?: Apollo.MutationHookOptions<PublishLongListMutation, PublishLongListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishLongListMutation, PublishLongListMutationVariables>(PublishLongListDocument, options);
      }
export type PublishLongListMutationHookResult = ReturnType<typeof usePublishLongListMutation>;
export type PublishLongListMutationResult = Apollo.MutationResult<PublishLongListMutation>;
export type PublishLongListMutationOptions = Apollo.BaseMutationOptions<PublishLongListMutation, PublishLongListMutationVariables>;
export const UnpublishLongListDocument = gql`
    mutation UnpublishLongList($nodeId: String!, $publishedDocumentId: String!, $prototypeId: String!) {
  unpublishLongList(
    nodeId: $nodeId
    publishedDocumentId: $publishedDocumentId
    prototypeId: $prototypeId
  ) {
    success
  }
}
    `;
export type UnpublishLongListMutationFn = Apollo.MutationFunction<UnpublishLongListMutation, UnpublishLongListMutationVariables>;

/**
 * __useUnpublishLongListMutation__
 *
 * To run a mutation, you first call `useUnpublishLongListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishLongListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishLongListMutation, { data, loading, error }] = useUnpublishLongListMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *      publishedDocumentId: // value for 'publishedDocumentId'
 *      prototypeId: // value for 'prototypeId'
 *   },
 * });
 */
export function useUnpublishLongListMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishLongListMutation, UnpublishLongListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishLongListMutation, UnpublishLongListMutationVariables>(UnpublishLongListDocument, options);
      }
export type UnpublishLongListMutationHookResult = ReturnType<typeof useUnpublishLongListMutation>;
export type UnpublishLongListMutationResult = Apollo.MutationResult<UnpublishLongListMutation>;
export type UnpublishLongListMutationOptions = Apollo.BaseMutationOptions<UnpublishLongListMutation, UnpublishLongListMutationVariables>;
export const ChangeFamilyDocument = gql`
    mutation ChangeFamily($longListParent: String!, $longListId: String!, $familyId: String!) {
  changeLongListCommercialFamily(
    longListParent: $longListParent
    longListId: $longListId
    familyId: $familyId
  ) {
    code
    success
    message
  }
}
    `;
export type ChangeFamilyMutationFn = Apollo.MutationFunction<ChangeFamilyMutation, ChangeFamilyMutationVariables>;

/**
 * __useChangeFamilyMutation__
 *
 * To run a mutation, you first call `useChangeFamilyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeFamilyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeFamilyMutation, { data, loading, error }] = useChangeFamilyMutation({
 *   variables: {
 *      longListParent: // value for 'longListParent'
 *      longListId: // value for 'longListId'
 *      familyId: // value for 'familyId'
 *   },
 * });
 */
export function useChangeFamilyMutation(baseOptions?: Apollo.MutationHookOptions<ChangeFamilyMutation, ChangeFamilyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeFamilyMutation, ChangeFamilyMutationVariables>(ChangeFamilyDocument, options);
      }
export type ChangeFamilyMutationHookResult = ReturnType<typeof useChangeFamilyMutation>;
export type ChangeFamilyMutationResult = Apollo.MutationResult<ChangeFamilyMutation>;
export type ChangeFamilyMutationOptions = Apollo.BaseMutationOptions<ChangeFamilyMutation, ChangeFamilyMutationVariables>;
export const SaveTrasversalGlsDocument = gql`
    mutation SaveTrasversalGls($glData: [GlData!]!, $modelIds: [String!]!) {
  saveTrasversalGls(glData: $glData, modelIds: $modelIds) {
    code
    success
    message
  }
}
    `;
export type SaveTrasversalGlsMutationFn = Apollo.MutationFunction<SaveTrasversalGlsMutation, SaveTrasversalGlsMutationVariables>;

/**
 * __useSaveTrasversalGlsMutation__
 *
 * To run a mutation, you first call `useSaveTrasversalGlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrasversalGlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrasversalGlsMutation, { data, loading, error }] = useSaveTrasversalGlsMutation({
 *   variables: {
 *      glData: // value for 'glData'
 *      modelIds: // value for 'modelIds'
 *   },
 * });
 */
export function useSaveTrasversalGlsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrasversalGlsMutation, SaveTrasversalGlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrasversalGlsMutation, SaveTrasversalGlsMutationVariables>(SaveTrasversalGlsDocument, options);
      }
export type SaveTrasversalGlsMutationHookResult = ReturnType<typeof useSaveTrasversalGlsMutation>;
export type SaveTrasversalGlsMutationResult = Apollo.MutationResult<SaveTrasversalGlsMutation>;
export type SaveTrasversalGlsMutationOptions = Apollo.BaseMutationOptions<SaveTrasversalGlsMutation, SaveTrasversalGlsMutationVariables>;
export const SavePrototypeGlForcedValuesDocument = gql`
    mutation SavePrototypeGlForcedValues($modelId: String!, $prototypes: [PrototypeGlForcedValues!]!) {
  savePrototypeGlForcedValues(modelId: $modelId, prototypes: $prototypes) {
    code
    success
    message
  }
}
    `;
export type SavePrototypeGlForcedValuesMutationFn = Apollo.MutationFunction<SavePrototypeGlForcedValuesMutation, SavePrototypeGlForcedValuesMutationVariables>;

/**
 * __useSavePrototypeGlForcedValuesMutation__
 *
 * To run a mutation, you first call `useSavePrototypeGlForcedValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePrototypeGlForcedValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePrototypeGlForcedValuesMutation, { data, loading, error }] = useSavePrototypeGlForcedValuesMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      prototypes: // value for 'prototypes'
 *   },
 * });
 */
export function useSavePrototypeGlForcedValuesMutation(baseOptions?: Apollo.MutationHookOptions<SavePrototypeGlForcedValuesMutation, SavePrototypeGlForcedValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePrototypeGlForcedValuesMutation, SavePrototypeGlForcedValuesMutationVariables>(SavePrototypeGlForcedValuesDocument, options);
      }
export type SavePrototypeGlForcedValuesMutationHookResult = ReturnType<typeof useSavePrototypeGlForcedValuesMutation>;
export type SavePrototypeGlForcedValuesMutationResult = Apollo.MutationResult<SavePrototypeGlForcedValuesMutation>;
export type SavePrototypeGlForcedValuesMutationOptions = Apollo.BaseMutationOptions<SavePrototypeGlForcedValuesMutation, SavePrototypeGlForcedValuesMutationVariables>;
export const UpdateCertificationStatusDocument = gql`
    mutation UpdateCertificationStatus($aggregateId: String!, $nodeId: String!, $contents: [NodeContent!]!, $documentVersion: String) {
  updateCertificationStatus(
    aggregateId: $aggregateId
    nodeId: $nodeId
    contents: $contents
    documentVersion: $documentVersion
  ) {
    code
    success
    message
  }
}
    `;
export type UpdateCertificationStatusMutationFn = Apollo.MutationFunction<UpdateCertificationStatusMutation, UpdateCertificationStatusMutationVariables>;

/**
 * __useUpdateCertificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCertificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificationStatusMutation, { data, loading, error }] = useUpdateCertificationStatusMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      nodeId: // value for 'nodeId'
 *      contents: // value for 'contents'
 *      documentVersion: // value for 'documentVersion'
 *   },
 * });
 */
export function useUpdateCertificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCertificationStatusMutation, UpdateCertificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCertificationStatusMutation, UpdateCertificationStatusMutationVariables>(UpdateCertificationStatusDocument, options);
      }
export type UpdateCertificationStatusMutationHookResult = ReturnType<typeof useUpdateCertificationStatusMutation>;
export type UpdateCertificationStatusMutationResult = Apollo.MutationResult<UpdateCertificationStatusMutation>;
export type UpdateCertificationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCertificationStatusMutation, UpdateCertificationStatusMutationVariables>;